import AdSlot from "../components/AdSlot.jsx";
import AppFooter from "../components/AppFooter.jsx";
import LanguageToggle from "../components/LanguageToggle.jsx";
import PlusUpgradePanel from "../components/PlusUpgradePanel.jsx";
import { levels, tools } from "../data/appCatalog.js";
import { useI18n } from "../i18n.jsx";
import { assetPath } from "../lib/legacyPaths.js";

export default function Home({ navigate }) {
  const { t } = useI18n();

  return (
    <div className="home-view">
      <header className="home-brand">
        <div className="home-language-row">
          <LanguageToggle />
        </div>
        <img
          src={assetPath("/common/main-page-assets/02_top_header_banner.webp")}
          alt={t("home.bannerAlt")}
        />
      </header>

      <AdSlot position="top" />

      <main className="home-main">
        <section className="home-hero" aria-labelledby="home-title">
          <h1 id="home-title" className="sr-only">{t("home.title")}</h1>
          <div className="home-hero-art">
            <img
              src={assetPath("/common/main-page-assets/03_choose_your_level_hero.webp")}
              alt=""
              aria-hidden="true"
            />
          </div>
          <div className="home-hero-copy">
            <p className="kicker">{t("home.kicker")}</p>
            <p>
              {t("home.intro")}
            </p>
          </div>
        </section>

        <section className="home-level-grid" aria-label={t("home.chooseLevel")}>
          {levels.map((level) => (
            <button
              className="home-level-card"
              key={level.id}
              type="button"
              aria-label={t("home.startLevel", { level: t(level.nameKey, {}, level.label) })}
              onClick={() => navigate(`/${level.id}`)}
              style={{ "--level-color": level.color, "--level-accent": level.accent }}
            >
              <span className="home-level-mark">
                <img src={assetPath(level.badge)} alt="" />
              </span>
              <span className="home-level-content">
                <strong>{t(level.nameKey, {}, level.label)}</strong>
                <span>{t(level.descriptionKey, {}, level.description)}</span>
                <span className="home-level-tools">
                  {level.tools.map((toolId) => t(tools[toolId].labelKey, {}, tools[toolId].label)).join(" / ")}
                </span>
              </span>
              <span className="home-level-action">{t("home.start")}</span>
            </button>
          ))}
        </section>

        <section className="home-plus" aria-labelledby="plus-title">
          <div>
            <p className="kicker">{t("home.optionalUpgrade")}</p>
            <h2 id="plus-title">SielpA Plus</h2>
            <p>{t("home.plusCopy")}</p>
          </div>
          <div className="plus-feature-grid">
            <article>
              <strong>{t("home.removeAdsTitle")}</strong>
              <span>{t("home.removeAdsCopy")}</span>
            </article>
            <article>
              <strong>{t("home.premiumVoiceTitle")}</strong>
              <span>{t("home.premiumVoiceCopy")}</span>
            </article>
            <article>
              <strong>{t("home.vocabBurstTitle")}</strong>
              <span>{t("home.vocabBurstCopy")}</span>
            </article>
          </div>
          <PlusUpgradePanel compact source="home-plus" />
        </section>

      </main>

      <AdSlot position="bottom" />

      <AppFooter />
    </div>
  );
}
